// extracted by mini-css-extract-plugin
export default {"mosaicGrid":"MosaicImage_mosaicGrid__K9GUe","flipped":"MosaicImage_flipped__qkYOV","mosaicTile":"MosaicImage_mosaicTile__LpHDL","tileInner":"MosaicImage_tileInner__awxoT"};